import { events } from '../../events';
import { BaseComponent } from '../../framework/base.component';
import { component } from '../../framework/component.decorator';
import { OnInit } from '../../framework/on-init.interface';
import { PlEvent } from '../../models/pl.event';
import { button } from '../../templating/button.element';
import { div } from '../../templating/div.element';
import { icon } from '../../templating/icon.element';
import { p } from '../../templating/p.element';
import { delay } from '../../utils/delay.fn';
import styles from './likes.component.scss';

@component({
  selector: 'app-likes',
  styles,
})
export class LikesComponent
  extends BaseComponent<LikesComponent>
  implements OnInit
{
  constructor() {
    super(LikesComponent);
  }

  async onInit() {
    events.on('convert-more', () => this.unlock());
  }

  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    return [
      div('buttons', [
        button(
          {
            onCreate: (element) => {
              element.addEventListener('click', () => this.like());
            },
          },
          [icon('hand-thumbs-up')]
        ),
        button(
          {
            onCreate: (element) => {
              element.addEventListener('click', () => this.dislike());
            },
          },
          [icon('hand-thumbs-down')]
        ),
      ]),
      p('note hidden d-none', { textContent: 'Thank you for voting!' }),
    ];
  }

  private like() {
    this.lock();
    document.dispatchEvent(new PlEvent({ goal: 'like' }));
  }

  private dislike() {
    this.lock();
    document.dispatchEvent(new PlEvent({ goal: 'dislike' }));
  }

  private async lock() {
    const buttons = this._root.querySelector('.buttons');
    const note = this._root.querySelector('.note');

    buttons?.classList.add('d-none', 'hidden');
    note?.classList.remove('d-none');
    await delay(1);
    note?.classList.remove('hidden');
  }

  private async unlock() {
    const buttons = this._root.querySelector('.buttons');
    const note = this._root.querySelector('.note');

    note?.classList.add('d-none', 'hidden');
    buttons?.classList.remove('d-none');
    await delay(1);
    buttons?.classList.remove('hidden');
  }
}
